import { render, staticRenderFns } from "./VInnerSpinner.vue?vue&type=template&id=c1947534&scoped=true"
import script from "./VInnerSpinner.vue?vue&type=script&lang=js"
export * from "./VInnerSpinner.vue?vue&type=script&lang=js"
import style0 from "./VInnerSpinner.vue?vue&type=style&index=0&id=c1947534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1947534",
  null
  
)

export default component.exports